// ------------------------------------------------------------------
//  Tiny browser helpers
// ------------------------------------------------------------------
export const isBrowser = typeof window !== 'undefined';

/** Safely run code only in the browser and swallow errors in prod. */
export function safeExecute(fn) {
  if (!isBrowser) return;
  try { fn(); }               // eslint-disable-line callback-return
  catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('[Analytics]', e);
    }
  }
}

/** Idempotent <script> injector (returns the element). */
export function loadScript({ id, src, async = true, onLoad, onError }) {
  if (!isBrowser) return null;
  const existing = document.getElementById(id);
  if (existing) return existing;

  const s = document.createElement('script');
  s.id     = id;
  s.async  = async;
  s.src    = src;
  if (onLoad)  s.onload  = onLoad;
  if (onError) s.onerror = onError;
  document.head.appendChild(s);
  return s;
}
